import customAxios from './axios';
import CONFIG from '../../config';

export const getAllDashboardJobs = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterStaffDashboard/Jobs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllRecentJobs = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterStaffDashboard/RecentJobs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllSLAForJobs = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterStaffDashboard/SLAForJobs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllMetrices = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterStaffDashboard/Metrices').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getJobsCount = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterAdminDashboard/JobCounts').then(res => {
        let response = res['data'];
        return response;
    });
};